import styled from 'styled-components';
import { Captions } from 'components/Typography';
import { SanlamOrange } from 'Material-UI/colors';

const StyledCaptions = styled(Captions)`
  letter-spacing: 0.1px !important;
  line-height: 17px !important;
  font-size: 13px !important;
  text-align: center !important;
  margin-left: -5px !important;
  margin-right: -5px !important;
`;
const CategoryCaptions = styled(Captions)`
  letter-spacing: 0.1px !important;
  font-size: 10px !important;
  text-align: center !important;
  margin-top: -12px !important;
`;

interface ItemStylesType {
  orange?: boolean;
  coloredBackground?: boolean;
}

const ItemWrapper = styled.div<ItemStylesType>`
  background-color: ${(props) =>
    props.orange
      ? SanlamOrange
      : props.coloredBackground
      ? '#6FAD37'
      : 'white'};
  border-radius: 6px;
  box-shadow: 0 1px 6px 0 rgba(43, 86, 210, 0.3);
  height: 107px;
  border: ${(props) => (props.orange ? '1px dashed rgba(0,0,0,0.3)' : 'none')};
  width: 104px;
  text-align: center;
  cursor: pointer;
  &: hover {
    opacity: 0.9;
    box-shadow: 0 3px 20px 0 rgba(0, 0, 0, 0.2) !important;
  }
`;

const ContentWrapper = styled.div`
  padding: 10px 8px 9px;
`;

const StyledIcon = styled.img`
  margin-top: 4px;
  margin-bottom: 4px;
  height: 26px;
  width: 28px;
`;
const StyledSmallIcon = styled.img`
  margin-top: 4px;
  margin-bottom: 6px;
  height: 28px;
  width: 21px;
`;

export {
  StyledCaptions,
  ItemWrapper,
  ContentWrapper,
  StyledIcon,
  StyledSmallIcon,
  CategoryCaptions,
};
